import { Inject, ISimpleControllerConfiguration, SimpleBaseController } from '@denishussar/html5-game-engine';
import { AppStateEnum, GameModel } from './Models/GameModel';
import { GameScreenController } from './Controllers/GameScreenController';
import { GameLogic } from './Logic/GameLogic';
import { CharacterScreenController } from './Controllers/Character/CharacterScreenController';
import { EndScreenController } from './Controllers/EndScreen/EndScreenController';
import { AfterloaderGameController } from './Controllers/AfterloadingController';
import { OrientationScreenController } from './Controllers/Common/OrientationScreenController';
import { FullscreenController } from './Controllers/Common/FullscreenController';

export interface IRootControllerOptions {
}

export class RootController extends SimpleBaseController {
    $model: GameModel;

    public constructor(@Inject private _options: IRootControllerOptions,
                       @Inject private _gameLogic: GameLogic) {
        super('RootController');
    }

    protected getConfiguration(): ISimpleControllerConfiguration {

        return {
            childControllers: {
                OrientationScreen: {
                    controller: OrientationScreenController,
                    model: this.$model,
                },
                Fullscreen: {
                    controller: FullscreenController,
                    model: this.$model,
                },
            },
            modelWatch: {
                appState: async (state: AppStateEnum) => {
                    const screen = this.$childControllers.get('screen');
                    if (screen) {
                        await this.removeChildControllerByNameAsync('screen');
                    }

                    switch (state) {
                        case AppStateEnum.afterloader:
                            await this.addChildControllerAsync(
                                {
                                    controller: AfterloaderGameController,
                                    model: this.$model,
                                    options: {
                                        isNewPlayer: this.$model.showAfterloaderScreenNewPlayer,
                                    },
                                },
                                false,
                                'screen',
                                0,
                            );
                            break;
                        // case AppStateEnum.menu:
                        //     await this.addChildControllerAsync(
                        //         {
                        //             controller: MenuScreenController,
                        //             model: this.$model,
                        //         },
                        //         true,
                        //         'screen',
                        //         0
                        //     );
                        //     break;

                        case AppStateEnum.game:
                            await this.addChildControllerAsync(
                                {
                                    controller: GameScreenController,
                                    model: this.$model,
                                },
                                true,
                                'screen',
                                0,
                            );
                            break;

                        case AppStateEnum.character:
                            await this.addChildControllerAsync(
                                {
                                    controller: CharacterScreenController,
                                    model: this.$model,
                                },
                                true,
                                'screen',
                                0,
                            );
                            break;

                        case AppStateEnum.end:
                            await this.addChildControllerAsync(
                                {
                                    controller: EndScreenController,
                                    model: this.$model,
                                },
                                true,
                                'screen',
                                0,
                            );
                            break;
                    }
                },
                
            },
        };
    }

    protected async onInitialize() {
        await this._gameLogic.initDB();
        await this._gameLogic.initStorage();
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }
}
